import { Route, Navigate } from 'react-router-dom';
import UserDashboardLayout from '../user-dashboard/layout';
import Dashboard from '../../view/dashboard/Dashboard';
import EventDashboard from '../../view/dashboard/manage/Event/event-dashboard/EventDashboard';
import CreateEvent from '../../view/dashboard/manage/Event/manage-details/event-details/CreateEvent';
import ManageTicket from '../../view/dashboard/manage/Event/Tickets/ManageTicket';
import Team from '../../view/dashboard/manage/Event/team/Team';
import Invitation from '../../view/dashboard/manage/Event/invitation/Invitation';
import Registration from '../../view/dashboard/manage/Event/registration/Registration';
import EventSettings from '../../view/dashboard/manage/Event/event-settings/EventSettings';

const eventDashboardRoutes = (
    <Route element={<UserDashboardLayout />}>
        <Route path="/event/:eventSlug" element={<Dashboard />}>
            {/* Redirect from /event to /event/dashboard */}
            <Route index element={<Navigate to="/event/dashboard" replace />} />
            <Route path="dashboard" element={<EventDashboard />} />
            <Route path="event-details" element={<CreateEvent />} />
            <Route path="tickets" element={<ManageTicket />} />
            <Route path="team" element={<Team />} />
            <Route path="invitations" element={<Invitation />} />
            <Route path="registrations" element={<Registration />} />
            <Route path="analytics" element={<Team />} />
            <Route path="reports" element={<Team />} />
            <Route path="help" element={<Team />} />
            <Route path="settings" element={<EventSettings />} />
            <Route path="logout" element={<Team />} />
        </Route>
    </Route>
);

export default eventDashboardRoutes;
